/* __next_internal_client_entry_do_not_use__ LoggedOutLoginSection auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getCurrentPath } from "@faire/web--source/common/Path";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { useHeaderSignUpCopy } from "../../__internal__/useHeaderSignUpCopy";
import { useNavigateAndHideMenu } from "../../mobile/Navigation/useNavigateAndHideMenu";
import { HeaderLinkButton } from "../../styled";
import { HeaderButton } from "../../styled";
export var LoggedOutLoginSection = function() {
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(LoginLink, {}),
            /*#__PURE__*/ _jsx(SignUpLink, {})
        ]
    });
};
var LoginLink = function() {
    var navigateToSignIn = useNavigateAndHideMenu().navigateToSignIn;
    return /*#__PURE__*/ _jsx(HeaderLinkButton, {
        onClick: function() {
            return navigateToSignIn();
        },
        "data-test-id": "login",
        children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "pRbY2n",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sign in"
                }
            ]
        })
    });
};
var SignUpLink = function() {
    var isSSR = useIsSSR();
    var navigateToSignUp = useNavigateAndHideMenu().navigateToSignUp;
    var signUpCopy = useHeaderSignUpCopy();
    return /*#__PURE__*/ _jsx(HeaderButton, {
        onClick: function() {
            return navigateToSignUp(undefined, {
                sourceId: "desktop_catnav_signup_cta"
            });
        },
        // We set a link for graceful degradation in SSR.
        linkTo: isSSR ? getCurrentPath().replace({
            signUp: "1"
        }).toString() : undefined,
        "data-test-id": "signUpButton",
        children: signUpCopy
    });
};
